//import libraries
import { Component, OnInit, AfterViewInit } from '@angular/core';

//import service
import { UserLayoutService } from '../../../services/UserLayout.service';

declare var MINOVATE:any;

@Component({
  selector: 'app-user-layout',
  templateUrl: './user-layout.component.html',
  styleUrls: ['./user-layout.component.css'],
  providers: [UserLayoutService]
})
export class UserLayoutComponent implements AfterViewInit{

  constructor(
  ) { }

  ngAfterViewInit() {

    setTimeout(function(){
      var MINOVATES = MINOVATE();
      MINOVATES.userLayout.init();
      MINOVATES.extra.slimScroll();
    }, 500);
    
  }

}
